// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/pages/ShipmentDetailsPage/ShipmentDetailsPage.css */

.shipment-details-page {
  animation: fadeIn 0.5s ease-in-out;
}

.details-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.back-button {
  display: flex;
  align-items: center;
  gap: 8px;
  background: none;
  border: none;
  font-size: 16px;
  font-weight: 500;
  color: #475569;
  cursor: pointer;
}

.back-button svg {
  font-size: 20px;
}

.add-shipment-btn {
  background-color: #f97316;
  color: white;
  border: none;
  padding: 10px 20px;
  font-size: 14px;
  font-weight: 600;
  border-radius: 8px;
  cursor: pointer;
}

.details-content-wrapper {
  background-color: #ffffff;
  border: 1px solid #f3f4f6;
  border-radius: 12px;
  padding: 32px;
}

.customer-info-header {
  display: flex;
  align-items: center;
  gap: 16px;
  padding-bottom: 24px;
  margin-bottom: 24px;
  border-bottom: 1px solid #f3f4f6;
}

.customer-info-header h2 {
  font-size: 24px;
  font-weight: 600;
  color: #174078;
  margin: 0;
}

.status-pill {
  padding: 4px 12px;
  border-radius: 16px;
  font-size: 12px;
  font-weight: 500;
  text-transform: capitalize;
}
/* You can reuse your status badge colors here */
.status-pill.status-packed,
.status-pill.status-delivered {
  background-color: #dcfce7;
  color: #166534;
}
.status-pill.status-in-transit {
  background-color: #fef9c3;
  color: #854d0e;
}
.status-pill.status-cancelled {
  background-color: #fee2e2;
  color: #991b1b;
}
.status-pill.status-checked_in {
  background-color: #dcfce7;
  color: #166534;
}
.status-pill.status-declined {
  background-color: #fee2e2;
  color: #991b1b;
}

.details-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr)); /* Equal width columns */
  gap: 50px 24px;
}

.detail-item .detail-label {
  display: block;
  font-size: 14px;
  color: #174078;
  margin-bottom: 8px;
}

.detail-item .detail-value {
  font-size: 15px;
  font-weight: 600;
  color: #174078;
  margin: 0;
}

@media (max-width: 900px) {
  .details-header {
    flex-direction: column;
    gap: 1rem;
  }
  .details-grid {
    grid-template-columns: 1fr;
    gap: 16px;
  }
}
@media (max-width: 600px) {
  .details-header {
    gap: 0.5rem;
  }
  .details-grid {
    gap: 8px;
  }
  .detail-item .detail-label,
  .detail-item .detail-value {
    font-size: 12px;
  }
}
.img-button {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
}

.avatar-container {
  width: 150px;
  height: 150px;
  border-radius: 50%;
  overflow: hidden;
  border: 2px solid #e0e0e0;
}

.customer-avatar {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.img-button {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 24px;
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  animation: fadeIn 0.3s ease-in-out;
}

.modal-content {
  background: white;
  border-radius: 16px;
  width: 90%;
  max-width: 600px;
  max-height: 90vh;
  overflow-y: auto;
  animation: slideIn 0.3s ease-out;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 24px 10px 16px;
  border-bottom: 1px solid #f3f4f6;
}

.modal-header h3 {
  font-size: 20px;
  font-weight: 600;
  color: #174078;
  margin: 0;
}

.modal-close {
  background: none;
  border: none;
  font-size: 24px;
  color: #6b7280;
  cursor: pointer;
  padding: 4px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
}

.modal-close:hover {
  background-color: #f3f4f6;
}

.modal-body {
  padding: 24px 10px;
}

.modal-section {
  margin-bottom: 24px;
}

.modal-section h4 {
  font-size: 16px;
  font-weight: 600;
  color: #174078;
  margin: 0 0 12px 0;
}

.items-text {
  color: #174078;
  font-size: 14px;
  margin: 0;
  line-height: 1.5;
}

.form-group {
  margin-bottom: 20px;
}

.form-group label {
  display: block;
  font-size: 14px;
  font-weight: 500;
  color: #174078;
  margin-bottom: 8px;
}

.form-group input,
.form-group textarea {
  width: 100%;
  padding: 12px 16px;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  font-size: 14px;
  color: #374151;
  background-color: #f9fafb;
  box-sizing: border-box;
}

.form-group input:focus,
.form-group textarea:focus {
  outline: none;
  border-color: #f97316;
  background-color: white;
}

.form-group input::placeholder,
.form-group textarea::placeholder {
  color: #9ca3af;
}

.reasons-section {
  margin-top: 24px;
}

.reasons-section p {
  font-size: 14px;
  color: #174078;
  margin: 0 0 16px 0;
}

.reason-pills {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.reason-pill {
  padding: 8px 16px;
  border: 1px solid #f97316;
  background: white;
  color: #f97316;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
}

.reason-pill:hover {
  background-color: #fff7ed;
}

.reason-pill.selected {
  background-color: #f97316;
  color: white;
}

.modal-footer {
  padding: 16px 32px 32px;
  display: flex;
  gap: 12px;
  justify-content: flex-start;
}

.btn {
  padding: 12px 24px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  border: none;
  transition: all 0.2s ease;
}

.btn-primary {
  background-color: #f97316;
  color: white;
}

.btn-primary:hover {
  background-color: #ea580c;
}

.btn-secondary {
  background-color: white;
  color: #f97316;
  border: 1px solid #f97316;
}

.btn-secondary:hover {
  background-color: #fff7ed;
}

.btn-decline {
  background-color: #f97316;
  color: white;
  min-width: 120px;
}

.btn-decline:hover {
  background-color: #ea580c;
}

/* Animations */
@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes slideIn {
  from {
    transform: translateY(-20px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

/* Mobile Responsiveness */
@media (max-width: 600px) {
  .modal-content {
    width: 95%;
    margin: 20px;
  }

  .modal-header,
  .modal-body,
  .modal-footer {
    padding-left: 20px;
    padding-right: 20px;
  }

  .modal-footer {
    flex-direction: column;
  }

  .btn {
    width: 100%;
  }

  .reason-pills {
    justify-content: center;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/ShipmentDetailsPage/ShipmentDetailsPage.css"],"names":[],"mappings":"AAAA,0DAA0D;;AAE1D;EACE,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,oBAAoB;EACpB,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;AACA,gDAAgD;AAChD;;EAEE,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,gDAAgD,EAAE,wBAAwB;EAC1E,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE;IACE,sBAAsB;IACtB,SAAS;EACX;EACA;IACE,0BAA0B;IAC1B,SAAS;EACX;AACF;AACA;EACE;IACE,WAAW;EACb;EACA;IACE,QAAQ;EACV;EACA;;IAEE,eAAe;EACjB;AACF;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,kCAAkC;AACpC;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,uBAAuB;EACvB,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,cAAc;EACd,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;;EAEE,aAAa;EACb,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,SAAS;EACT,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,eAAe;AACf;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,4BAA4B;IAC5B,UAAU;EACZ;EACA;IACE,wBAAwB;IACxB,UAAU;EACZ;AACF;;AAEA,0BAA0B;AAC1B;EACE;IACE,UAAU;IACV,YAAY;EACd;;EAEA;;;IAGE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,uBAAuB;EACzB;AACF","sourcesContent":["/* src/pages/ShipmentDetailsPage/ShipmentDetailsPage.css */\n\n.shipment-details-page {\n  animation: fadeIn 0.5s ease-in-out;\n}\n\n.details-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 20px;\n}\n\n.back-button {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  background: none;\n  border: none;\n  font-size: 16px;\n  font-weight: 500;\n  color: #475569;\n  cursor: pointer;\n}\n\n.back-button svg {\n  font-size: 20px;\n}\n\n.add-shipment-btn {\n  background-color: #f97316;\n  color: white;\n  border: none;\n  padding: 10px 20px;\n  font-size: 14px;\n  font-weight: 600;\n  border-radius: 8px;\n  cursor: pointer;\n}\n\n.details-content-wrapper {\n  background-color: #ffffff;\n  border: 1px solid #f3f4f6;\n  border-radius: 12px;\n  padding: 32px;\n}\n\n.customer-info-header {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  padding-bottom: 24px;\n  margin-bottom: 24px;\n  border-bottom: 1px solid #f3f4f6;\n}\n\n.customer-info-header h2 {\n  font-size: 24px;\n  font-weight: 600;\n  color: #174078;\n  margin: 0;\n}\n\n.status-pill {\n  padding: 4px 12px;\n  border-radius: 16px;\n  font-size: 12px;\n  font-weight: 500;\n  text-transform: capitalize;\n}\n/* You can reuse your status badge colors here */\n.status-pill.status-packed,\n.status-pill.status-delivered {\n  background-color: #dcfce7;\n  color: #166534;\n}\n.status-pill.status-in-transit {\n  background-color: #fef9c3;\n  color: #854d0e;\n}\n.status-pill.status-cancelled {\n  background-color: #fee2e2;\n  color: #991b1b;\n}\n.status-pill.status-checked_in {\n  background-color: #dcfce7;\n  color: #166534;\n}\n.status-pill.status-declined {\n  background-color: #fee2e2;\n  color: #991b1b;\n}\n\n.details-grid {\n  display: grid;\n  grid-template-columns: repeat(4, minmax(0, 1fr)); /* Equal width columns */\n  gap: 50px 24px;\n}\n\n.detail-item .detail-label {\n  display: block;\n  font-size: 14px;\n  color: #174078;\n  margin-bottom: 8px;\n}\n\n.detail-item .detail-value {\n  font-size: 15px;\n  font-weight: 600;\n  color: #174078;\n  margin: 0;\n}\n\n@media (max-width: 900px) {\n  .details-header {\n    flex-direction: column;\n    gap: 1rem;\n  }\n  .details-grid {\n    grid-template-columns: 1fr;\n    gap: 16px;\n  }\n}\n@media (max-width: 600px) {\n  .details-header {\n    gap: 0.5rem;\n  }\n  .details-grid {\n    gap: 8px;\n  }\n  .detail-item .detail-label,\n  .detail-item .detail-value {\n    font-size: 12px;\n  }\n}\n.img-button {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.5rem;\n}\n\n.avatar-container {\n  width: 150px;\n  height: 150px;\n  border-radius: 50%;\n  overflow: hidden;\n  border: 2px solid #e0e0e0;\n}\n\n.customer-avatar {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.img-button {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 24px;\n}\n\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n  animation: fadeIn 0.3s ease-in-out;\n}\n\n.modal-content {\n  background: white;\n  border-radius: 16px;\n  width: 90%;\n  max-width: 600px;\n  max-height: 90vh;\n  overflow-y: auto;\n  animation: slideIn 0.3s ease-out;\n}\n\n.modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 24px 10px 16px;\n  border-bottom: 1px solid #f3f4f6;\n}\n\n.modal-header h3 {\n  font-size: 20px;\n  font-weight: 600;\n  color: #174078;\n  margin: 0;\n}\n\n.modal-close {\n  background: none;\n  border: none;\n  font-size: 24px;\n  color: #6b7280;\n  cursor: pointer;\n  padding: 4px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n}\n\n.modal-close:hover {\n  background-color: #f3f4f6;\n}\n\n.modal-body {\n  padding: 24px 10px;\n}\n\n.modal-section {\n  margin-bottom: 24px;\n}\n\n.modal-section h4 {\n  font-size: 16px;\n  font-weight: 600;\n  color: #174078;\n  margin: 0 0 12px 0;\n}\n\n.items-text {\n  color: #174078;\n  font-size: 14px;\n  margin: 0;\n  line-height: 1.5;\n}\n\n.form-group {\n  margin-bottom: 20px;\n}\n\n.form-group label {\n  display: block;\n  font-size: 14px;\n  font-weight: 500;\n  color: #174078;\n  margin-bottom: 8px;\n}\n\n.form-group input,\n.form-group textarea {\n  width: 100%;\n  padding: 12px 16px;\n  border: 1px solid #e5e7eb;\n  border-radius: 8px;\n  font-size: 14px;\n  color: #374151;\n  background-color: #f9fafb;\n  box-sizing: border-box;\n}\n\n.form-group input:focus,\n.form-group textarea:focus {\n  outline: none;\n  border-color: #f97316;\n  background-color: white;\n}\n\n.form-group input::placeholder,\n.form-group textarea::placeholder {\n  color: #9ca3af;\n}\n\n.reasons-section {\n  margin-top: 24px;\n}\n\n.reasons-section p {\n  font-size: 14px;\n  color: #174078;\n  margin: 0 0 16px 0;\n}\n\n.reason-pills {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n\n.reason-pill {\n  padding: 8px 16px;\n  border: 1px solid #f97316;\n  background: white;\n  color: #f97316;\n  border-radius: 20px;\n  font-size: 12px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.reason-pill:hover {\n  background-color: #fff7ed;\n}\n\n.reason-pill.selected {\n  background-color: #f97316;\n  color: white;\n}\n\n.modal-footer {\n  padding: 16px 32px 32px;\n  display: flex;\n  gap: 12px;\n  justify-content: flex-start;\n}\n\n.btn {\n  padding: 12px 24px;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  border: none;\n  transition: all 0.2s ease;\n}\n\n.btn-primary {\n  background-color: #f97316;\n  color: white;\n}\n\n.btn-primary:hover {\n  background-color: #ea580c;\n}\n\n.btn-secondary {\n  background-color: white;\n  color: #f97316;\n  border: 1px solid #f97316;\n}\n\n.btn-secondary:hover {\n  background-color: #fff7ed;\n}\n\n.btn-decline {\n  background-color: #f97316;\n  color: white;\n  min-width: 120px;\n}\n\n.btn-decline:hover {\n  background-color: #ea580c;\n}\n\n/* Animations */\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n@keyframes slideIn {\n  from {\n    transform: translateY(-20px);\n    opacity: 0;\n  }\n  to {\n    transform: translateY(0);\n    opacity: 1;\n  }\n}\n\n/* Mobile Responsiveness */\n@media (max-width: 600px) {\n  .modal-content {\n    width: 95%;\n    margin: 20px;\n  }\n\n  .modal-header,\n  .modal-body,\n  .modal-footer {\n    padding-left: 20px;\n    padding-right: 20px;\n  }\n\n  .modal-footer {\n    flex-direction: column;\n  }\n\n  .btn {\n    width: 100%;\n  }\n\n  .reason-pills {\n    justify-content: center;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
